import React, { createContext, useContext, useState, useRef, ReactNode } from "react"

interface MediaContextType {
    stream: MediaStream | null
    setStream: (stream: MediaStream | null) => void
    isCameraOn: boolean
    setIsCameraOn: (isOn: boolean) => void
    isMicOn: boolean
    setIsMicOn: (isOn: boolean) => void
    videoRef: React.RefObject<HTMLVideoElement>
    availableCameras: MediaDeviceInfo[]
    setAvailableCameras: (devices: MediaDeviceInfo[]) => void
    availableMicrophones: MediaDeviceInfo[]
    setAvailableMicrophones: (devices: MediaDeviceInfo[]) => void
    availableSpeakers: MediaDeviceInfo[]
    setAvailableSpeakers: (devices: MediaDeviceInfo[]) => void
}

const MediaContext = createContext<MediaContextType | undefined>(undefined)

export const MediaProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [stream, setStream] = useState<MediaStream | null>(null)
    const [isCameraOn, setIsCameraOn] = useState(false)
    const [isMicOn, setIsMicOn] = useState(false)
    const [availableCameras, setAvailableCameras] = useState<MediaDeviceInfo[]>([])
    const [availableMicrophones, setAvailableMicrophones] = useState<MediaDeviceInfo[]>([])
    const [availableSpeakers, setAvailableSpeakers] = useState<MediaDeviceInfo[]>([])
    const videoRef = useRef<HTMLVideoElement>(null)

    return (
        <MediaContext.Provider
            value={{
                stream,
                setStream,
                isCameraOn,
                setIsCameraOn,
                isMicOn,
                setIsMicOn,
                videoRef,
                availableCameras,
                setAvailableCameras,
                availableMicrophones,
                setAvailableMicrophones,
                availableSpeakers,
                setAvailableSpeakers,
            }}
        >
            {children}
        </MediaContext.Provider>
    )
}

export const useMedia = () => {
    const context = useContext(MediaContext)
    if (!context) {
        throw new Error("useMedia must be used within MediaProvider")
    }
    return context
}

